import React, { Component } from 'react';

import Issue from './Issue';
import ViewIssue from './ViewIssue';

import { api } from '../api/index.js';

class LookupIssues extends Component {
  constructor() {
    super();

    this.state = {
      issues: [],
      formControls: [],
      loadingControls: true,
      controlsError: null,
      workOrders: [],
      selectedIssue: false,
      email: '',
      noResults: false,
      searching: false
    };

    this.handleViewCancel = this.handleViewCancel.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSearchByEmailAddress = this.handleSearchByEmailAddress.bind(this);
    this.trackEmailValue = this.trackEmailValue.bind(this);
  }

  componentDidMount() {
    this.setState({ issues: [] });
    // Load customer-specific form controls, falling back to global manifest
    api.configurations.getCustomerFields()
      .then(response => {
        const controls = response.selectedFields || [];
        this.setState({ formControls: controls, loadingControls: false });
      })
      .catch(err => {
        console.error('Error loading customer fields, falling back to global:', err);
        api.configurations.getFormControls()
          .then(resp => {
            const controls = resp.formControls || resp.data || [];
            this.setState({ formControls: controls, loadingControls: false });
          })
          .catch(err2 => {
            console.error('Error loading global fields:', err2);
            this.setState({ formControls: [], loadingControls: false, controlsError: err2 });
          });
      });
  }

  handleSelect(issue) {
    this.setState({ selectedIssue: issue });
  }

  handleDelete(event, issue) {
    event.stopPropagation();

    // Use the new API for deleting issues
    api.issues.delete(issue.id)
      .then(() => {
        let issues = this.state.issues;
        issues = issues.filter(h => h !== issue);
        this.setState({ issues: issues });

        if (this.selectedIssue === issue) {
          this.setState({ selectedIssue: null });
        }
      })
      .catch(err => {
        console.error(err);
      });
  }

  async handleSearchByEmailAddress() {
    const email = this.state.email;
    this.setState({ searching: true });

    // Email validation check
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Invalid email address');
      this.setState({ searching: false });
      return;
    }

    try {
      // Use the new API method
      const json = await api.issues.getByEmail(email);
      console.log(json);
      this.setState({ issues: json })
      if (json.length === 0) {
        this.setState({ noResults: true });
      } else {
        this.setState({ noResults: false });
      }
      this.setState({ searching: false });
    } catch (err) {
      console.error(err);
      this.setState({ searching: false });
    }
  }

  trackEmailValue(event) {
    this.setState({ email: event.target.value });
  }

  isSearchDisabled() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return !emailRegex.test(this.state.email);
  }

  // Cancel view/edit
  handleViewCancel() {
    this.setState({ selectedIssue: false });
  }

  render() {
    return (
      <div>
        <div className='container p-4'>
          <h1 className="my-4">Find an Existing Request</h1>
          <p>
            Enter the email address you used when you submitted the request to find the status of your submitted requests.
          </p>

          <input
            type="email"
            className='w-100 border-rounded p-2 ps-2 my-4'
            name="email"
            placeholder="Search by creator's email address"
            onChange={this.trackEmailValue}
          />
          {
            this.state.searching && <p>Searching...</p>
          }
          {
            this.isSearchDisabled() || this.state.searching ?
              <button className="btn btn-dark w-100 mt-1 mb-4"
                disabled>Search</button>
              :
              <button className="btn btn-dark w-100 mt-1 mb-4"
                onClick={this.handleSearchByEmailAddress}>Search</button>
          }
          {
            this.state.noResults && <p>No results found</p>
          }
          {
            this.state.issues.map(issue => {
              return (
                <Issue
                  key={issue.id}
                  issue={issue}
                  onSelect={this.handleSelect}
                  onDelete={this.handleDelete}
                  selectedIssue={this.state.selectedIssue}
                />
              );
            })
          }
          {
            this.state.selectedIssue && (
              <div className="mt-4">
                <ViewIssue
                  formControls={this.state.formControls}
                  issue={this.state.selectedIssue}
                  onClose={this.handleViewCancel}
                />
              </div>
            )
          }
          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
    );
  }
}

export default LookupIssues;
